import React from 'react';
import './style.scss';

const Layout = ({ children }) => {
  return (
    <>
      <div className="lay-out__container">{children}</div>
    </>
  );
};

export default Layout;
